// MARK: React
import * as React from "react";
import "./style.scss";

// MARK: Mobx
import { observer, inject } from "mobx-react";

// MARK: Resources
import { match as Match } from "react-router";
import strings from "../../../../resources/strings";

// MARK: Components
import ItemDetail from "../../../../components/ItemDetail";
import Button from "../../../../components/Button";

// MARK: Stores
import CommentStore from "src/stores/CommentStore";

// MARK: Layout
import DashboardLayout from "../../../../layouts/DashboardLayout";

interface IProps extends IStores {}

interface IStores {
	commentStore: CommentStore;
	match: Match<{ id: string }>;
}

@inject("commentStore")
@observer
export default class CommentDetails extends React.Component<IProps> {
	public static defaultProps: IStores;

	public componentDidMount = async () => {
		const id = this.props.match.params.id;
		await this.props.commentStore.getComment(id);
	};

	public render() {
		const {commentStore} = this.props;
		return (
			<>
				{
					commentStore.comment && (
						<DashboardLayout backButton={true} loading={commentStore.loading}>
						<div className="itemDetailsContainer">
							<div className="itemDetailsWrapper">
								<div className="itemDetailsTitle">
									<h2>{strings.comment.title}</h2>
								</div>
								<div className="itemRow">
									<div className="itemTreeColumns image">
									{commentStore.comment.userInfo && (
											<>
												<ItemDetail
													title={strings.comment.ownerComment}
													info={commentStore.comment.userInfo.name}
												/>
												<ItemDetail
													title={strings.comment.nickname}
													info={commentStore.comment.userInfo.nick}
												/>
											</>
										)}
										<ItemDetail
											title={strings.comment.table.header.comment}
											info={commentStore.comment.text}
										/>
										<Button
											style={{ marginTop: 20 }}
											onClick={() => commentStore.openDeleteCommentDialog(this.props.match.params.id)}
										>
												{strings.comment.deleteCommentDialog.title}
										</Button>
									</div>
								</div>
							</div>
						</div>
					</DashboardLayout>
					)
				}
			</>
		);
	}
}
